import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid'
import { deleteUser, getUser } from '../Store/ActionCreators/UserActionCreator'
import { useDispatch, useSelector } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
export default function UserPage() {
    const columns = [
         {
    field: "sn",
    headerName: "S.No",
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return page * pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id) + 1;
    }
    },
    {
        field :'name',
        headerName:"Admin Name",
        width:150,
    },
    {
        field :'mobile',
        headerName:"Mobile",
        width:150,
    },
    {
        field :'email',
        headerName:"Email Address",
        width:200,
    },
    {
        field :'role',
        headerName:"Role",
        width:120,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 110,
      editable: true,
    },
    {
        field: 'edit',
        headerName: 'Edit',
        sortable: false,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            navigate("/updatecategory/" + row._id)
          }}>
           <EditIcon style={{color:"grayblue"}}/>
          </Button>,
      },
      {
        field: 'delete',
        headerName: 'Delete',
        width: 120,
        editable: true,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            dispatch(deleteUser({ _id: row._id }))
          }
          }>
            <DeleteIcon style={{color:"red"}}/>
          </Button>
      },
      {
        field: 'view',
        headerName: 'View',
        sortable: false,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            navigate("/userprofile/" + row._id)
          }}>
           <VisibilityIcon style={{color:"grayblue"}}/>
          </Button>,
      },
    ]
    const dispatch = useDispatch()
      const notifactionList = useSelector((state)=>state.UserStateData) 
      const [page, setPage] = useState(0);
      const [pageSize, setPageSize] = useState(10);
      const navigate = useNavigate()
      
      const rows = notifactionList || [];
    
      useEffect(()=>{
        dispatch(getUser())
      },[dispatch])
  return (
    <>
    <Box sx={{ display: "flex" ,width:"100%" }}>
        <Sidebar/>
        <Box className="boxStyle">
            <h4 className='bg-dark text-light p-1 text-center rounded mt-2 mb-3' style={{
              fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
            }}>User Details <span style={{ float: 'right', fontWeight: "bold", marginRight: "10px" }}><Link to="/addnotifaction" style={{ textDecoration: "none", color: "#fff" }}>+</Link></span></h4>
        <h5 className='text-right'style={{textAlign: "right"}}>Total Category : {notifactionList.length}</h5>
                <Box sx={{ height: 620, width: '100%' }}>
                  <DataGrid
                  sx={{
            border: "1px solid #636363ff",
            "& .MuiDataGrid-cell": {
              border: "1px solid #dad8d8ff",
            },
            "& .MuiDataGrid-columnHeaders": {
              borderBottom: "1px solid #636363ff",
            },
            textAlign:"center"
          }}
        
          rows={notifactionList}
          columns={columns}
          getRowId={(row) => row._id}
          pageSizeOptions={[5, 10, 20]}
          pagination
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => {
            setPage(model.page);
            setPageSize(model.pageSize);
          }}
        />
        
                </Box>
        </Box>
    </Box>
    </>
  )
}
